<template>
  <div class="success-page">
    <habit-item-element style="margin-top: 50px;"
      :haveAnimation="true"
      v-if="habit" :isCheckObject="successRate" :habit="habit"/>
    <div style="width: 100%; text-align: center;">
      <b-button
        style="margin: 20px; width: 70%;"
        v-if="habit && habit.habitUrl"
        @click="openLink(habit.habitUrl)"
        type="is-primary">Open link</b-button>
    </div>
    <div v-if="status === 'error'">
      <span @click="checkHabit">Error!</span>
    </div>
  <div style="text-align: center; font-weight: 800; font-size: 30px;"
    v-show="showMeme">
        {{ $t(`${translationPath}.successMessage`) }}</div>
    <div class="success__wrapper" v-show="showMeme">
      <div
        style="width: 100%; height: 0; padding-bottom: 112%; position: relative"
      >
        <iframe
          :src="`https://giphy.com/embed/${selectedGif}`"
          width="100%"
          height="100%"
          style="position: absolute"
          frameBorder="0"
          class="giphy-embed"
          allowFullScreen
        />
      </div>
    </div>
    <div v-if="isOnStandalone">
      <router-link to="/HabitsDashboard">
        <b-button type="is-primary" expanded>{{ $t(`${translationPath}.backToApp`) }}</b-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import HabitItemElement from './HabitsDashboard/components/HabitItemElement.vue';

const axios = require('axios').default;

export default {
  components: { HabitItemElement },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.$router.replace({ query: null });
      this.checkHabit(this.id);
    } else this.$router.push({ path: '/' });
  },
  data() {
    return {
      successRate: {},
      open: true,
      translationPath: 'succesPage',
      id: '',
      habit: null,
      showMeme: false,
      status: 'waiting',
      statuses: ['waiting', 'success', 'error'],
      gifs: [
        'nqi89GMgyT3va',
        'kmqCVSHi5phMk',
        'kmYBXYUp3K8lG',
        'Kto2WhhTPwRcQ',
        'xNBcChLQt7s9a',
        'o75ajIFH0QnQC3nCeD',
        'Sculsk7YRnRpvMZrR3',
        'l3q2Z6S6n38zjPswo',
        '3o6gE4rZPKadpLT9ew',
        'DIDovO2zZGxEI',
        '13loE6KAz7u0iuECjX',
        '3ohzdX7Wzbebc3Y0qA',
        '3oEduKVQdG4c0JVPSo',
        'ddHhhUBn25cuQ',
        'a0h7sAqON67nO',
        'Ww4wgq0LhdiNXdq6dj',
        '3OwWjqWzTHYWSRHRtu',
        'zEJRrMkDvRe5G',
        'nXxOjZrbnbRxS',
        'jRoYlnVecizuXyVMjc',
        '13MCWeJPQtkdVe',
        '37nRXpCEP9H1f1WVrb',
        'vtVpHbnPi9TLa',
        'XreQmk7ETCak0',
        'b6oC7bEdJD26c',
      ],
    };
  },
  computed: {
    selectedGif() {
      return this.gifs[Math.floor(Math.random() * this.gifs.length)];
    },
    isOnStandalone() {
      return window.matchMedia('(display-mode: standalone)').matches;
    },
  },
  methods: {
    openLink(url) {
      window.open(url);
    },
    async checkHabit() {
      const isLocal = window.location.origin.includes('localhost');
      let localUrl = '';
      let globalUrl = '';
      const createRequestUrl = () => {
        const passwordForElement = localStorage.getItem(this.id);

        localUrl = passwordForElement
          ? `http://localhost:5001/jedeadmin/us-central1/app/webhook/${this.id}?pass=${passwordForElement}`
          : `http://localhost:5001/jedeadmin/us-central1/app/webhook/${this.id}`;
        globalUrl = passwordForElement
          ? `https://us-central1-jedeadmin.cloudfunctions.net/app/webhook/${this.id}?pass=${passwordForElement}`
          : `https://us-central1-jedeadmin.cloudfunctions.net/app/webhook/${this.id}`;
      };
      const apiRequest = async () => {
        try {
          createRequestUrl();
          const request = await axios({
            method: 'get',
            url: isLocal ? localUrl : globalUrl,
          });

          return request;
        } catch (e) {
          this.status = 'error';
          alert(e);
          return 'error';
        }
      };
      const askPassword = async () => {
        const showPromp = () => prompt(this.$t(`${this.translationPath}.typePassword`));
        const pass = showPromp();
        localStorage.setItem(this.id, pass);
      };

      let requestCount = 0;
      const checkPassword = async () => {
        const response = await apiRequest();
        if (response === 'error') return;
        requestCount += 1;

        if (requestCount > 3) {
          this.status = 'error';

          return;
        }

        if (response.data === 'password incorrect') {
          await askPassword();
          await checkPassword();
        } else {
          this.habit = response.data.habit;
          this.successRate = response.data.successRate;
          this.status = 'success';
          setTimeout(() => {
            this.showMeme = true;
          }, 2000);
        }
      };
      await checkPassword();

      // next({ path: '/welcome' });
    },
  },
};
</script>

<style scoped lang='scss'>
.success-page {
  height: 100vh;
  width: 100vw;
}
.success {
  &__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.btn {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: $background-light-color;
    box-shadow:
        0 2.8px 4.2px rgba(0, 0, 0, 0.01),
        0 6.7px 5.3px rgba(0, 0, 0, 0.01),
        0 12.5px 10px rgba(0, 0, 0, 0.01),
        0 22.3px 17.9px rgba(0, 0, 0, 0.01),
        0 41.8px 33.4px rgba(0, 0, 0, 0.01),
        0 100px 80px rgba(0, 0, 0, 0.01);
    width: 100px;
    border-radius: 30px;
    padding: 13px 5px;
    transition-property: width;
    transition-duration: 2s;
    transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
}

</style>
